// components/Countdown.tsx
import React, { useEffect, useState } from "react";

export default function Countdown() {
  const targetDate = "2025-12-06T23:59:59";

  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    // Update countdown every second
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div
      className="relative w-full flex justify-center -mt-12 z-20 px-4"
      data-aos="fade-up"
    >
      <div
        className="bg-[#4E5C36] text-white rounded-2xl shadow-xl px-8 py-10 md:py-12 flex flex-col md:flex-row md:justify-between md:items-center w-full max-w-5xl"
        data-aos="zoom-in"
        data-aos-delay="200"
      >
        {/* Left side */}
        <div
          className="text-center md:text-left mb-8 md:mb-0 md:pr-12"
          data-aos="fade-right"
          data-aos-delay="300"
        >
          <h3
            className="text-2xl md:text-3xl font-semibold text-gray-200"
            data-aos="fade-down"
            data-aos-delay="400"
          >
            Until Event Start
          </h3>
          <p
            className="text-sm md:text-base tracking-widest text-gray-300"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            Time Remaining
          </p>
        </div>

        {/* Right side countdown */}
        <div
          className="flex justify-center md:justify-end text-center font-mono"
          data-aos="fade-left"
          data-aos-delay="600"
        >
          {[
            { label: "Days", value: timeLeft.days },
            { label: "Hrs", value: timeLeft.hours },
            // { label: "Mins", value: timeLeft.minutes },
            // { label: "Secs", value: timeLeft.seconds },
          ].map((item, idx, arr) => (
            <div
              key={idx}
              className="flex items-start"
              data-aos="zoom-in"
              data-aos-delay={700 + idx * 100}
            >
              {/* Value + Label */}
              <div className="flex flex-col items-center">
                <p className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-wide">
                  {String(item.value).padStart(2, "0")}
                </p>
                <span className="text-[#95822C] text-sm md:text-base uppercase tracking-widest">
                  {item.label}
                </span>
              </div>

              {/* Colon (except after last item) */}
              {idx < arr.length - 1 && (
                <span className="mx-2 md:mx-3 lg:mx-4 text-4xl md:text-5xl lg:text-6xl font-bold">
                  :
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
